<div class="alert alert-danger mt-4" role="alert" *ngIf="errorMessage !== ''">
  {{ errorMessage }}
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="(errorMessage === '') && (serverError === null)">

  <h2>
    Proficiencies
    <span *ngIf="loadingProficiencies" class="text-secondary">- Loading...</span>
  </h2>

  <p class="text-secondary">
    Proficiencies here can be used throughout Capitan.
  </p>

  <div class="row">
    <div class="col-xl-6 col-lg-8">

      <div class="alert"
           [class.alert-success]="modalResult.status === CallbackResultStatus.success"
           *ngIf="modalResult !== null">
        {{ modalResult.text }}
      </div>

      <div class="rounded-table-wrapper">
        <table class="table">

          <thead>
            <tr>
              <th style="width: 50px;">Icon</th>
              <th>Name</th>
              <th></th>
            </tr>
          </thead>

          <tbody>

            <ng-container *ngIf="proficiencyResultsPresent()">
              <tr *ngFor="let proficiency of proficiencyList">
                <td class="proficiency-icon-cell">
                  <app-proficiency-icon [colorHex]="proficiency.icon_color_hex"
                                        [iconInitials]="proficiency.icon_initials"></app-proficiency-icon>
                </td>
                <td>{{ proficiency.name }}</td>
                <td class="table-button-cell">
                  <button class="btn btn-outline-primary btn-sm float-right"
                          (click)="openEditProficiencyModal(proficiency)">
                    Edit
                  </button>
                  <button class="btn btn-outline-danger btn-sm float-right mr-2"
                          (click)="openRemoveProficiencyModal(proficiency)">
                    Remove
                  </button>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="!proficiencyResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingProficiencies ? 'Loading...' : 'No proficiencies' }}
              </td>
            </tr>
            </ng-container>

            <tr *ngIf="!loadingProficiencies">
              <td colspan="99" class="table-button-cell">
                <button class="btn btn-outline-success btn-block"
                        (click)="openAddProficiencyModal()">
                  Click to add
                </button>
              </td>
            </tr>

          </tbody>

        </table>
      </div>
    </div>
  </div>

</div>
